import { Component, OnInit, Input, Output } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ProductSolicitationDialog } from "../product-solcititation-dialog/product-solicitation-dialog.component";

@Component({
  selector: "product-description-dialog",
  templateUrl: "./product-description-dialog.component.html",
  styleUrls: ["./product-description-dialog.component.scss"]
})
export class ProductDescriptionDialog implements OnInit {
  @Input("productDescription") productDescription: string;
  @Input("productId") productId: string;
  @Input("producTitle") productTitle: string;
  @Input("siteName") siteName: string;
  @Input("documentType") documentType: string;
  @Input("productName") productName: string;

  constructor(
    public matDialogRef: MatDialogRef<ProductDescriptionDialog>,
    public dialog: MatDialog
  ) {}

  ngOnInit() {}

  closeDialog(close: boolean) {
    this.matDialogRef.close({ close: close });
  }

  openModalSolicitation() {
    let modalRef = this.dialog.open(ProductSolicitationDialog, {
      width: "1000px",
      height: "600px"
    });

    modalRef.componentInstance.productId = this.productId;
    modalRef.componentInstance.siteName = this.siteName;
    modalRef.componentInstance.documentType = this.documentType;
    modalRef.componentInstance.productName = this.productName;
  }
}
